import store from './store'
import { qs, qsa } from './utils'
import { GlobalRaf, GlobalResize, Emitter } from './events'

import Experience from './experience/Experience'
import Cosmos from './experience/world/Cosmos'

import { getGPUTier } from 'detect-gpu'

import ScrollAnimations from './components/ScrollAnimations'
import Intro from './components/Intro'

import gsap from 'gsap'

import Smooth from './components/Smooth'

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}    

export default class App {
  constructor() {
    // Viewport height
    // this.calculateVh()
    // window.addEventListener('resize', () => this.calculateVh())

    console.log(
      `%c${store.title} \nMade with ❤️ by ${store.author.name} \n↳ ${store.author.link}`,
      'color: #342f2f',
    )    

    // Animate mouse icon
    this.animateIcon()

    // WebGL
    this.canvas = qs('#gl')

    this.start()
  }

  calculateVh() {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)    
  }

  animateIcon() {
    let elem = qs('.slide')
    let tl = gsap.timeline({
      repeat: -1,
      duration: 1,
    })

    tl
      .to(elem, {
        y: '100%',
        ease: 'power3.in'
      })
      .set(elem, { y: '-100%' })
      .to(elem, {
        y: '0%',
        ease: 'power3.out'
      })
  }

  start() {
    const gpuTier = getGPUTier()
    gpuTier.then((res) => {
      if (window.location.hash === '#debug') {
        console.log(res)
      }

      store.benchmark = res

      this.experience = new Experience(this.canvas)    

      Emitter.on('gl:start', this.init)
    })
  }

  init = () => {
    // console.log('App: initialize')
    const smoothScroll = new Smooth()

    gsap.delayedCall(0.1, () => store.scroll.resize())

    const intro = new Intro()
    const introTl = intro.createTimeline()

    // Scroll animations
    const scrollAnim = new ScrollAnimations()
  }
}